// extracted by mini-css-extract-plugin
export default {"reviewItem":"reviewItem__QOoGc","title":"title__RGkCP","imgWrapper":"imgWrapper__GSFLT","text":"text__H4Eoe","description":"description__K1wxK","large":"large__0Fvqt"};